// import * as Sentry from '@sentry/vue';
import { emailSchema, resetPasswordTokenSchema } from "~/utils/schemas";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  const token = to.query.token;
  const email = to.query.email;

  try {
    emailSchema.parse(email);
    resetPasswordTokenSchema.parse(token);
  } catch {
    showError({
      statusMessage: "Nieprawidłowy link do zmiany hasła. Spróbuj ponownie.",
    });
    // Sentry.captureException(new Error('Invalid password reset link'));
  }
});
